export default __webpack_public_path__ + "static/media/smaller_bd2i.157804cd.png";